import { css } from 'styled-components';

/**
 * Removes default browser styling for buttons so that custom styling can be added, excluding focus styles.
 *
 * Also sets the cursor to 'pointer', which is this library's convention.
 */
const buttonResetStyle = css`
  border: none;
  background: none;
  padding: 0;

  cursor: pointer;
`;

/**
 * Removes default browser styling for buttons so that custom styling can be added, including focus styles.
 *
 * Also sets the cursor to 'pointer', which is this library's convention.
 */
export const buttonResetStyleIncludingFocus = css`
  ${buttonResetStyle};

  /* Use && to increase specificity, otherwise this is ignored by Firefox and the default
  styling persists. */
  &&:focus-visible {
    outline: none;
  }
`;

export default buttonResetStyle;
